import React from 'react';
import { Icon } from '@mui/material';

const isMuiIcon = (icon) => {
  return typeof icon === 'object'
}
export const IconHot = ({ src, size = 24, alt = '', style, className, onClick }) => (
  isMuiIcon(src) ? (
    <Icon component={src} fontSize="small" />
  ) : (
  <img
    src={src}
    alt={alt}
    onClick={onClick}
    className={className}
    style={{
      width: size,
      height: size,
      ...style,
    }}
  />
)
);

export default IconHot;

